import { initTabbedChats } from 'crosstalk-comments-livechat-sdk';
import { autoInitAISummaries } from './CrossTalkAISummaryEmbed';
import { autoInitComments } from './CrossTalkCommentsEmbed';
import { autoInitPolls } from './CrossTalkPollEmbed';
import { autoInitPlayers } from './CrossTalkVideoPlayerEmbed';
import { autoInitChats } from './CrossTalkLiveChatEmbed';
import { autoInitShareBars } from './CrossTalkShareBarEmbed';
import { autoInitFollowBars } from './CrossTalkFollowBarEmbed';
const CTCore = {
    init() {
        console.log('ct initialised');
        autoInitComments();
        autoInitPlayers();
        autoInitPolls();
        autoInitAISummaries();
        autoInitChats();
        autoInitShareBars();
        autoInitFollowBars();
        return this;
    },
    initTabbedChats(config) {
        initTabbedChats(config);
    }
};
export * from './CrossTalkCommentsEmbed';
export * from './CrossTalkVideoPlayerEmbed';
export * from './CrossTalkPollEmbed';
export * from './CrossTalkAISummaryEmbed';
export * from './CrossTalkLiveChatEmbed';
export * from './CrossTalkShareBarEmbed';
export * from './CrossTalkFollowBarEmbed';
if (typeof window !== 'undefined') {
    console.log("in browser");
    window.CTCore = CTCore;
    if (document.readyState === 'loading')
        document.addEventListener('DOMContentLoaded', () => CTCore.init());
    else
        CTCore.init();
}
